import  {useState} from 'react'
import ScriptList from './ScriptList'

const CustomerScript = () => {
  const [settingsAdded,setSettingsAdded]=useState<boolean>(true)


  return (
    <>
      <div
        className='d-flex flex-row justify-content-between align-items-center mb-5'
      >
        <div className='d-flex flex-column'>
          <span className='fs-3 fw-bold text-gray-900'>TPV Script List</span>
          <span className='text-gray-500 fw-semibold lh-20px fs-7'>Home - TPV Script</span>
        </div>
      </div>
      <ScriptList settingsAdded={settingsAdded}/>     
      </>)
}

export default CustomerScript
